// extracted by mini-css-extract-plugin
export var productImage = "_q5-1";
export var viewLink = "_q5-2";
export var wishlistItem = "_q5-0";